import React from 'react';
import Typography from '../Typography';
import styles from './readreview-tw-styles';
import constants from '../../../constants/messages/pt-BR';

class ReviewIntro extends React.Component {
  static defaultProps = {
    avgRating: 0,
    readReviewPath: '',
    title: '',
    maxRating: 5,
    reviewCount: 0,
  };

  averageOverallRatingFormat(avgOverAllRating) {
    if (avgOverAllRating % 1 == 0) {
      return avgOverAllRating;
    } else {
      return avgOverAllRating.toFixed(2);
    }
  }

  render() {
    return (
      <div className={styles.readreviewintro.wrapper}>
        <Typography component="h2" className={styles.readreviewintro.heading}>
          {constants.ratingsReviews}
        </Typography>
      </div>
    );
  }
}

export default ReviewIntro;
